import { parseFileResponse, parseListResponse } from "lib/fetch";
import { downloadInvoiceRequest, getInvoicesRequest } from "lib/api/invoice";

export const fetchInvoices = (params?: HashMap<unknown>) =>
    parseListResponse<unknown>(getInvoicesRequest(params));

export const downloadInvoice = (bookingId: string) =>
    parseFileResponse(downloadInvoiceRequest(bookingId));

export const invoiceKeys = {
    all: ["invoice"] as const,
    lists: () => [...invoiceKeys.all, "list"] as const,
};
